






















import Vue from 'vue'
import * as echarts from 'echarts'
import EchartsPrs from './EchartsPrs'
export default Vue.extend({
  props: {
    data: { type: Array },
    typeStr: { type: String }
  },
  mounted() {
    this.echarts()
  },
  watch: {
    data(val) {
      this.echarts()
    }
  },
  data() {
    return {
      isFull: false
    }
  },
  methods: {
    echarts() {
      const dom: any = document.getElementById('echartsPrs')
      const myChart: any = echarts.init(dom) // 基于准备好的dom，初始化echarts实例
      window.onresize = myChart.resize;  // 图表宽度自适应
      const chartData = this.data
      //@ts-ignore
      myChart.setOption(EchartsPrs(chartData,''))
    },
    fullScreen() {
      this.isFull = true;
      let fullEchart = document.getElementById('prsFull');
      const myChart: any = echarts.init(fullEchart) // 基于准备好的dom，初始化echarts实例
      window.onresize = myChart.resize;  // 图表宽度自适应
      //@ts-ignore
      myChart.setOption(EchartsPrs(this.data,'full'))
    },
    exitFullScreen() {
      this.isFull = false
    }
  }
})
